__webpack_require__.p = "/dance-studio-wroclaw/";